<template>
  <div class="add-owner-invoice-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('addOwnerInvoice.title')" :subtitle="$t('addOwnerInvoice.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="goBack">
          {{ $t('addOwnerInvoice.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="submitForm">
          {{ $t('addOwnerInvoice.save') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- 表单面板 -->
    <div class="ds-panel">
      <el-form ref="form" :model="formData" :rules="rules" label-width="150px" label-position="right" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item :label="$t('addOwnerInvoice.owner')" prop="ownerName">
              <div class="ds-inline-field">
                <el-input v-model="formData.ownerName" class="ds-inline-field__input" disabled
                  :placeholder="$t('addOwnerInvoice.placeholder.owner')" />
                <el-button type="primary" class="ds-inline-field__action" @click="openOwnerDialog">
                  {{ $t('addOwnerInvoice.selectOwner') }}
                </el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item :label="$t('addOwnerInvoice.invoiceType')" prop="invoiceType">
              <el-select v-model="formData.invoiceType" class="w-full"
                :placeholder="$t('addOwnerInvoice.placeholder.invoiceType')">
                <el-option v-for="item in invoiceTypes" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item :label="$t('addOwnerInvoice.invoiceTitle')" prop="invoiceName">
              <el-input v-model="formData.invoiceName" class="w-full"
                :placeholder="$t('addOwnerInvoice.placeholder.invoiceTitle')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item :label="$t('addOwnerInvoice.taxNumber')" prop="invoiceNum">
              <el-input v-model="formData.invoiceNum" class="w-full"
                :placeholder="$t('addOwnerInvoice.placeholder.taxNumber')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item :label="$t('addOwnerInvoice.address')" prop="invoiceAddress">
              <el-input v-model="formData.invoiceAddress" class="w-full"
                :placeholder="$t('addOwnerInvoice.placeholder.address')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item :label="$t('addOwnerInvoice.phone')" prop="invoiceLink">
              <el-input v-model="formData.invoiceLink" class="w-full"
                :placeholder="$t('addOwnerInvoice.placeholder.phone')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item :label="$t('addOwnerInvoice.bankAccount')" prop="invoiceAccount">
              <el-input v-model="formData.invoiceAccount" class="w-full"
                :placeholder="$t('addOwnerInvoice.placeholder.bankAccount')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('addOwnerInvoice.remarks')">
              <el-input v-model="formData.remark" type="textarea" :rows="3" class="w-full"
                :placeholder="$t('addOwnerInvoice.placeholder.remarks')" />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 表单操作区 -->
        <div class="ds-form-actions">
          <el-button icon="el-icon-close" @click="goBack">
            {{ $t('addOwnerInvoice.back') }}
          </el-button>
          <el-button type="primary" icon="el-icon-check" @click="submitForm">
            {{ $t('addOwnerInvoice.save') }}
          </el-button>
        </div>
      </el-form>
    </div>

    <search-owner ref="searchOwner" :visible.sync="showOwnerDialog" @chooseOwner="handleOwnerSelect" />
  </div>
</template>

<script>
import { saveOwnerInvoice } from '@/api/fee/addOwnerInvoiceApi'
import SearchOwner from '@/components/owner/SearchOwner'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'AddOwnerInvoice',
  components: {
    SearchOwner,
    DsPageHeader
  },
  data() {
    return {
      showOwnerDialog: false,
      formData: {
        oiId: '',
        ownerId: '',
        ownerName: '',
        invoiceType: '',
        invoiceName: '',
        invoiceNum: '',
        invoiceAddress: '',
        invoiceLink: '',
        invoiceAccount: '',
        remark: ''
      },
      invoiceTypes: [
        { value: '1001', label: this.$t('addOwnerInvoice.personal') },
        { value: '2002', label: this.$t('addOwnerInvoice.enterprise') }
      ],
      rules: {
        ownerName: [
          { required: true, message: this.$t('addOwnerInvoice.validation.ownerRequired'), trigger: 'blur' }
        ],
        invoiceType: [
          { required: true, message: this.$t('addOwnerInvoice.validation.typeRequired'), trigger: 'change' }
        ],
        invoiceName: [
          { required: true, message: this.$t('addOwnerInvoice.validation.titleRequired'), trigger: 'blur' }
        ],
        invoiceNum: [
          { required: true, message: this.$t('addOwnerInvoice.validation.taxNumberRequired'), trigger: 'blur' }
        ],
        invoiceAddress: [
          { required: true, message: this.$t('addOwnerInvoice.validation.addressRequired'), trigger: 'blur' }
        ],
        invoiceLink: [
          { required: true, message: this.$t('addOwnerInvoice.validation.phoneRequired'), trigger: 'blur' }
        ],
        invoiceAccount: [
          { required: true, message: this.$t('addOwnerInvoice.validation.bankAccountRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openOwnerDialog() {
      this.$refs.searchOwner.open()
    },
    handleOwnerSelect(owner) {
      this.formData.ownerId = owner.ownerId
      this.formData.ownerName = owner.name
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const payload = {
              ...this.formData,
              communityId: this.getCommunityId()
            }

            await saveOwnerInvoice(payload)
            this.$message.success(this.$t('common.operationSuccess'))
            this.goBack()
          } catch (error) {
            console.error('保存失败:', error)
            this.$message.error(error.message || this.$t('common.saveFailed'))
          }
        }
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.add-owner-invoice-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  padding: var(--ds-spacing-lg);
}

/* 表单 */
.ds-form {
  .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }
}

/* 输入框 + 按钮 */
.ds-inline-field {
  display: flex;
  align-items: center;
  gap: var(--ds-spacing-sm);

  &__input {
    flex: 1 1 auto;
  }

  &__action {
    flex-shrink: 0;
  }
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding-top: var(--ds-spacing-md);
  border-top: 1px solid var(--ds-gray-200);
}
</style>
